const TechActionType = {
  SET_TECH_VALUE: 'SET_TECH_VALUE',
  SET_TECH_NAME: 'SET_TECH_NAME',
  SET_TECH_ID: 'SET_TECH_ID',
  RESET:'RESET_DATA'
};

export default TechActionType;